import { Project } from "./pictureValidator";
import { ProjectHandleComponent } from "./ProjectHandleComponent";
import { SelectionComponent } from "./SelectionComponent";
import { ProjectTagsComponent } from "./ProjectTagsComponent";
import { MoveProjectAssetComponent } from "./MoveProjectAssetComponent";
import { AssetPreviewComponent } from "./AssetPreviewComponent";
import { AddAssetComponent } from "./AddAssetComponent";
export var TopProjectComponent = {
    components: {
        'project-handle-component': ProjectHandleComponent,
        'selection-component': SelectionComponent,
        'project-tags-component': ProjectTagsComponent,
        'move-project-asset-component': MoveProjectAssetComponent,
        'asset-preview-component': AssetPreviewComponent,
        'add-asset-component': AddAssetComponent,
    },
    props: {
        project: Project,
        availableProjects: Array,
        availableTags: Array,
    },
    data: function () {
        return {
            previewMode: true
        };
    },
    computed: {
        selectedAssets: function () {
            // return this.project.assets;
            return this.project.assets.filter(function (asset) { return asset.isSelected; });
        },
        selectedAssetsHaveSameAuthor: function () {
            if (this.selectedAssets.length === 0)
                return false;
            var firstAssetUser = this.selectedAssets[0].handle;
            return !this.selectedAssets.some(function (asset) {
                return asset.handle !== firstAssetUser;
            });
        },
        firstSelectedAsset: function () {
            return this.selectedAssets[0];
        },
        commonTags: function () {
            var selectedAssets = this.selectedAssets;
            var tags = selectedAssets.map(function (asset) { return asset.tags.map(function (tag) { return tag.idTag; }); });
            var commonTagIds = tags.reduce(function (a, b) { return a.filter(function (c) { return b.includes(c); }); });
            return commonTagIds.map(function (idTag) {
                var assetWithSearchedTag = selectedAssets.find(function (selectedAsset) {
                    return selectedAsset.tags.filter(function (currentTag) {
                        return currentTag.idTag === idTag;
                    });
                });
                return assetWithSearchedTag.tags.find(function (tag) { return tag.idTag === idTag; });
            });
        },
        assetsForSelection: function () {
            return this.project.assets.filter(function (asset) { return !asset.isValidated && !asset.needsUpload; });
        }
    },
    methods: {
        dateString: function (date) {
            return date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear();
        },
        moveSelectedAssetsToProject: function (idProject) {
            this.previewMode = true;
        },
        addUploadedAssets: function (uploadedAssets) {
            var _this = this;
            uploadedAssets.forEach(function (asset) { return asset.idProject = _this.project.idProject; });
            this.project.assets = this.project.assets.concat(uploadedAssets);
        },
        updateProjectId: function (project) {
            this.project.idProject = project.idProject;
            this.project.handle = project.handle.substr(project.handle.indexOf('-') + 1);
            this.project.assets.forEach(function (asset) { return asset.idProject = project.idProject; });
        },
        unselectValidatedAssets: function () {
            this.project.assets.forEach(function (asset) {
                if (asset.isValidated && asset.isSelected)
                    asset.isSelected = false;
            });
            this.$emit('on-unselect-other-projects-assets');
        },
        toggleCollapse: function () {
            if (this.project.isCollapsed)
                this.project.isCollapsed = false;
        },
        toggleCollapseByIcon: function () {
            if (!this.project.isCollapsed)
                this.project.isCollapsed = true;
        }
    },
    template: "\n        <div class='top-row' @click='toggleCollapse'>\n            <div class='first-col'>\n                <project-handle-component\n                :project='project'\n                :available-projects='availableProjects'\n                :editable='!project.isCollapsed'\n                v-on:on-id-project-updated='updateProjectId'></project-handle-component>\n\n                <div class='bottom'>\n                    <div class='first-col'>\n                        <div class='first-row'>\n                            <div v-if='selectedAssetsHaveSameAuthor'class='information'>\n                                <span class='user'>{{firstSelectedAsset.handle}}</span>\n                                <span class='date'>{{dateString(firstSelectedAsset.date)}}</span>\n                            </div>\n\n                            <project-tags-component\n                                v-if='selectedAssets.length > 0'\n                                :selected-assets='selectedAssets'\n                                :common-tags='commonTags'\n                                :available-tags='availableTags'></project-tags-component>\n                        </div>\n\n                        <div class='move-container'\n                            :class=\"{disabled: selectedAssets.length === 0 || !previewMode}\"\n                            @click='previewMode = !previewMode'>\n                            <img src='/src/assets/icons/moveicon.svg'>\n                            <button>D\u00E9placer</button>\n                        </div>\n                    </div>\n\n\n                    <div class='second-col'>\n                        <move-project-asset-component\n                            v-if='!previewMode'\n                            :availableProjects='availableProjects'\n                            v-on:on-cancel-move='previewMode = true'></move-project-asset-component>\n                        <asset-preview-component\n                            v-if='selectedAssets.length > 0 && previewMode'\n                            :selected-assets='selectedAssets'\n                            :previewMode='previewMode'></asset-preview-component>\n                    </div>\n                </div>\n            </div>\n            <selection-component\n                :assets='assetsForSelection'\n                v-on:on-asset-selection-click='unselectValidatedAssets'></selection-component>\n            <add-asset-component\n                :is-collapsed='project.isCollapsed'\n                v-on:on-toggle-collapse-project='toggleCollapseByIcon'\n                v-on:on-assets-uploaded='addUploadedAssets'></add-asset-component>\n        </div>\n    ",
    created: function () {
        // EventBus.$emit('onTest', 'something');
    }
};
